let deadline = 0;
let review = 0;
let finalPrice = 0;
let priceRule = 0;
let image = "";
let imageUrl = "";
const productId = ShopifyAnalytics.meta.product.id;
const form = document.querySelector("[data-formulario]");
const formFields = form.querySelectorAll("[required]");
const formRadioFields = document.querySelectorAll(".radio-containers");
const submitButton = form.querySelector('button[type="submit"]');
const priceDiv = document.getElementsByClassName("custom-price")[0];
const priceUnitdiv = document.getElementsByClassName("custom-unitprice")[0];
const inputFile = document.querySelector("#picture__input");
const pictureImage = document.querySelector(".picture__image");
const pictureImageTxt = "Clique para selecionar o arquivo da sua arte";
const artworkCheckbox = document.getElementById("artwork");
//const deadlineCheckbox = document.getElementById("deadline");
//const reviewCheckbox = document.getElementById("review");
let messages = "";
const pictureInputContainer = document.getElementById("pictureInputContainer");


pictureImage.innerHTML = pictureImageTxt;
pictureInputContainer.style.display = "none";
submitButton.disabled = true;
//deadlineCheckbox.required = false;
//reviewCheckbox.required = false;

inputFile.addEventListener("change", function (e) {
  const inputTarget = e.target;
  const file = inputTarget.files[0];

  if (file) {
    const reader = new FileReader();

    reader.addEventListener("load", function (e) {
      const readerTarget = e.target;

      const img = document.createElement("img");
      img.src = readerTarget.result;
      img.classList.add("picture__img");

      pictureImage.innerHTML = "";
      pictureImage.appendChild(img);
    });

    reader.readAsDataURL(file);
  } else {
    pictureImage.innerHTML = pictureImageTxt;
  }
});

const showLoading = (show) => {
  if (show) {
    document.getElementsByClassName("add-to-cart")[0].style.display = "none";
    document.getElementsByClassName("second-button")[0].style.display = "block";
  } else {
    document.getElementsByClassName("add-to-cart")[0].style.display = "block";
    document.getElementsByClassName("second-button")[0].style.display = "none";
  }
};

const addProduct = () => {
  showLoading(true);
  createVariant();
};

const createVariant = () => {
//  if (reviewCheckbox.checked) {
//    review = 1.5;
//  } else {
//    review = 0;
//  }
//  if (deadlineCheckbox.checked) {
//    deadline = 9.9;
//  } else {
//    deadline = 0;
//  }
  fetch("https://stickeriasantista.vercel.app/api/variantcreate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      productId: productId,
      productType: ShopifyAnalytics.meta.product.variants[0].name.toLowerCase(),
      width: parseFloat(document.getElementById("width").value / 100),
      height: parseFloat(document.getElementById("height").value / 100),
      quantity: parseFloat(document.getElementById("quantity").value),
      deadline: deadline,
      review: review
    }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.productVariantCreate.productVariant) {
        addToCart(
          parseFloat(
            response.productVariantCreate.productVariant.id.replace(
              "gid://shopify/ProductVariant/",
              ""
            )
          )
        );
      } else {
        console.log(response.productVariantCreate.userErrors[0].message);
        showLoading(false);
      }
    })
    .catch((err) => console.error(err));
};

const deleteVariant = (variantId) => {
  $.ajax({
    url: "https://stickeriasantista.vercel.app/api/deletevariant",
    type: "post",
    data: {
      productId: variantId,
    },
  })
    .done(function (res) {
      if (res) {
        console.log(res);
      }
    })
    .fail(function (jqXHR, textStatus, res) {
      alert(
        "Produto já adicionado, modifique as informação para adicionar um novo produto personalizado"
      );
    });
};

const addToCart = (variantId) => {
//  if (reviewCheckbox.checked) {
//    review = 1.5;
//  } else {
//    review = 0;
//  }
//  if (deadlineCheckbox.checked) {
//    deadline = 9.9;
//  } else {
//    deadline = 0;
//  }
  let formData = {
    id: variantId,
    quantity: 1,
    properties: {
      Acabamento: document.getElementById("lamination").value,
      Corte: document.getElementById("cutline").value,
      Largura: document.getElementById("width").value + " cm",
      Altura: document.getElementById("height").value + " cm",
      Quantidade: document.getElementById("quantity").value + " unidades",
      Prazo: deadline,
      Revisao: review,
      Arte: imageUrl ? imageUrl : "Enviar depois",
    },
    sections: $("cart-drawer")[0]
      .getSectionsToRender()
      .map((section) => section.id),
    sections_url: window.location.pathname,
  };
  $.ajax({
    url: "/cart/add.js",
    data: formData,
    type: "POST",
    async: false,
    dataType: "json",
    success: function (data) {
      console.log(data);

      setTimeout(() => {
        $("cart-drawer")[0].renderContents(data);
      }, 750);
      $("cart-drawer").removeClass("is-empty");
      $("cart-drawer")[0].open();
      showLoading(false);
    },
    error: function (data) {
      console.log(data);
      //Show error here
    },
  });
};

setInterval(() => {
  setTimeout(() => {
    $(".cart__price").each(function (index) {
      if ($(this).text().includes("0,00")) {
        $(this).text("Em processamento...");
        validateCart();
      }
    });
  }, 300);
}, 250);

const validateCart = () => {
  setTimeout(() => {
    $("cart-drawer")[0].open();
  }, 750);
};

function validateSize(field) {
  const size = parseFloat(field.value);
  if (
    ShopifyAnalytics.meta.product.variants[0].name
      .toLowerCase()
      .includes("Mega".toLowerCase())
  ) {
    if (size < 30 || size > 98) {
      field.setCustomValidity("Esse valor é inválido para o campo.");
    }
  } else {
    if (size < 3 || size > 30) {
      field.setCustomValidity("Esse valor é inválido para o campo.");
    }
  }
}

function validateQuantity(field) {
 if (field.value < 10) {
      field.setCustomValidity("Esse valor é inválido para o campo.");
    }
}

function validateArtwork(field) {
  const pictureInputContainer = document.getElementById(
    'pictureInputContainer'
  );
  if (field.value === "Sim") {
    pictureInputContainer.style.display = "block";
    inputFile.required = true;
  } else {
    pictureInputContainer.style.display = "none";
    inputFile.required = false;
    inputFile.value = "";
    pictureImage.innerHTML = pictureImageTxt;
  }
}

function validatePicture(field) {
  if (field.value.includes(".cdr")) {
    Swal.fire({
      title: "Formato de arquivo inválido!",
      text: 'Não é permitido arquivos no formato ".cdr", tente outro formato.',
      icon: "error",
      confirmButtonText: "Fechar",
    });
    field.setCustomValidity(
      'Não é permitido arquivos no formato ".cdr", tente outro formato.'
    );
  } else {
    image = field.files[0];
    handleImageUpload();
  }
}

const validateUpload = (state) => {
  if (state) {
    document.getElementsByClassName("send-image")[0].style.display = "none";
    document.getElementsByClassName("loading-upload")[0].style.display =
      "block";
  } else {
    document.getElementsByClassName("send-image")[0].style.display = "block";
    document.getElementsByClassName("loading-upload")[0].style.display = "none";
  }
};

const handleImageUpload = () => {
  validateUpload(true);
  const formData = new FormData();
  formData.append("file", image);
  formData.append("upload_preset", "stickeria-santista");

  fetch("https://api.cloudinary.com/v1_1/dzlbhjb9x/image/upload", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.secure_url !== "") {
        validateUpload(false);
        imageUrl = data.secure_url;
      }
    })
    .catch((err) => {
      Swal.fire({
        title: "Ocorreu um erro!",
        text: err,
        icon: "error",
        confirmButtonText: "Fechar",
      });
      validateUpload(false);
    });
};

const errorTypes = ["valueMissing", "typeMismatch", "customError"];

if (
  ShopifyAnalytics.meta.product.variants[0].name
    .toLowerCase()
    .includes("Mega".toLowerCase())
) {
  messages = {
    cutline: {
      valueMissing: "O campo de tipo de corte não pode estar vazio.",
      customError: "Selecione um valor.",
    },
    width: {
      valueMissing: "O campo de largura não pode estar vazio.",
      customError: "Digite um valor entre 30 e 98.",
    },
    height: {
      valueMissing: "O campo de altura não pode estar vazio.",
      customError: "Digite um valor entre 30 e 98.",
    },
    quantity: {
      valueMissing: "O campo de quantidade não pode estar vazio.",
      customError: "A quantidade mínima é 10 unidades.",
    },
    artwork: {
      valueMissing: "O campo de seleção de arquivo não pode estar vazio.",
      customError: "Selecione um arquivo válido.",
    },
    picture__input: {
      valueMissing: "Você deve enviar um arquivo válido.",
      customError:
        'Não é permitido arquivos no formato ".cdr", tente outro formato.',
    },
    deadline: {
      valueMissing: "O campo de prazo de produção não pode estar vazio.",
      customError: "Selecione um valor.",
    },
  };
} else {
  messages = {
    cutline: {
      valueMissing: "O campo de tipo de corte não pode estar vazio.",
      customError: "Selecione um valor.",
    },
    width: {
      valueMissing: "O campo de largura não pode estar vazio.",
      customError: "Digite um valor entre 3 e 30.",
    },
    height: {
      valueMissing: "O campo de altura não pode estar vazio.",
      customError: "Digite um valor entre 3 e 30.",
    },
    quantity: {
      valueMissing: "O campo de quantidade não pode estar vazio.",
      customError: "A quantidade mínima é 10 unidades.",
    },
    artwork: {
      valueMissing: "O campo de seleção de arquivo não pode estar vazio.",
      customError: "Selecione um arquivo válido.",
    },
    picture__input: {
      valueMissing: "Você deve enviar um arquivo válido.",
      customError:
        'Não é permitido arquivos no formato ".cdr", tente outro formato.',
    },
    deadline: {
      valueMissing: "O campo de prazo de produção não pode estar vazio.",
      customError: "Selecione um valor.",
    },
  };
}

form.addEventListener("submit", (e) => {
  e.preventDefault();
  addProduct();
  console.log("Certo");
});

function getRules() {
  height = parseFloat(document.getElementById("height").value / 100);
  width = parseFloat(document.getElementById("width").value / 100);
  quantity = parseFloat(document.getElementById("quantity").value);
  if (
    ShopifyAnalytics.meta.product.variants[0].name
      .toLowerCase()
      .includes("Vinil".toLowerCase())
  ) {
    if (height * width * quantity <= 0.1249) {
      priceRule = 667;
    }

    if (
      height * width * quantity > 0.1249 &&
      height * width * quantity <= 0.249
    ) {
      priceRule = 505;
    }

    if (
      height * width * quantity > 0.249 &&
      height * width * quantity <= 0.499
    ) {
      priceRule = 345;
    }

    if (height * width * quantity > 0.499 && height * width * quantity <= 0.999) {
      priceRule = 287;
    }

    if (height * width * quantity > 0.999 && height * width * quantity <= 1.499) {
      priceRule = 193;
    }

    if (height * width * quantity > 1.499 && height * width * quantity <= 1.999) {
      priceRule = 189;
    }

    if (height * width * quantity > 1.999 && height * width * quantity <= 2.499) {
      priceRule = 184;
    }

    if (height * width * quantity > 2.499 && height * width * quantity <= 2.999) {
      priceRule = 180;
    }

    if (height * width * quantity > 2.999 && height * width * quantity <= 3.999) {
      priceRule = 174;
    }

    if (height * width * quantity > 3.999 && height * width * quantity <= 4.999) {
      priceRule = 165;
    }

    if (height * width * quantity > 4.999 && height * width * quantity <= 7.999) {
      priceRule = 156;
    }

    if (height * width * quantity > 7.999 && height * width * quantity <= 9.999) {
      priceRule = 141;
    }

    if (height * width * quantity > 9.999 && height * width * quantity <= 14.999) {
      priceRule = 127;
    }

    if (height * width * quantity > 14.999) {
      priceRule = 115;
    }
  }

  if (
    ShopifyAnalytics.meta.product.variants[0].name
      .toLowerCase()
      .includes("Poliéster".toLowerCase())
  ) {
    if (height * width * quantity <= 0.1249) {
      priceRule = 867.1;
    }

    if (
      height * width * quantity > 0.1249 &&
      height * width * quantity <= 0.249
    ) {
      priceRule = 656.5;
    }

    if (
      height * width * quantity > 0.249 &&
      height * width * quantity <= 0.499
    ) {
      priceRule = 448.5;
    }

    if (height * width * quantity > 0.499 && height * width * quantity <= 0.999) {
      priceRule = 373.1;
    }

    if (height * width * quantity > 0.999 && height * width * quantity <= 1.499) {
      priceRule = 250.9;
    }

    if (height * width * quantity > 1.499 && height * width * quantity <= 1.999) {
      priceRule = 245.7;
    }

    if (height * width * quantity > 1.999 && height * width * quantity <= 2.499) {
      priceRule = 239.2;
    }

    if (height * width * quantity > 2.499 && height * width * quantity <= 2.999) {
      priceRule = 234;
    }

    if (height * width * quantity > 2.999 && height * width * quantity <= 3.999) {
      priceRule = 226.2;
    }

    if (height * width * quantity > 3.999 && height * width * quantity <= 4.999) {
      priceRule = 214.5;
    }

    if (height * width * quantity > 4.999 && height * width * quantity <= 7.999) {
      priceRule = 202.8;
    }

    if (height * width * quantity > 7.999 && height * width * quantity <= 9.999) {
      priceRule = 183.3;
    }

    if (height * width * quantity > 9.999 && height * width * quantity <= 14.999) {
      priceRule = 165.1;
    }

    if (height * width * quantity > 14.999) {
      priceRule = 149.5;
    }
  }

  if (
    ShopifyAnalytics.meta.product.variants[0].name
      .toLowerCase()
      .includes("Tag".toLowerCase())
  ) {
    if (height * width * quantity <= 0.1249) {
      priceRule = 867.1;
    }

    if (
      height * width * quantity > 0.1249 &&
      height * width * quantity <= 0.249
    ) {
      priceRule = 656.5;
    }

    if (
      height * width * quantity > 0.249 &&
      height * width * quantity <= 0.499
    ) {
      priceRule = 448.5;
    }

    if (height * width * quantity > 0.499 && height * width * quantity <= 0.999) {
      priceRule = 373.1;
    }

    if (height * width * quantity > 0.999 && height * width * quantity <= 1.499) {
      priceRule = 250.9;
    }

    if (height * width * quantity > 1.499 && height * width * quantity <= 1.99) {
      priceRule = 245.7;
    }

    if (height * width * quantity > 1.999 && height * width * quantity <= 2.499) {
      priceRule = 239.2;
    }

    if (height * width * quantity > 2.499 && height * width * quantity <= 2.999) {
      priceRule = 234;
    }

    if (height * width * quantity > 2.999 && height * width * quantity <= 3.999) {
      priceRule = 226.2;
    }

    if (height * width * quantity > 3.999 && height * width * quantity <= 4.999) {
      priceRule = 214.5;
    }

    if (height * width * quantity > 4.999 && height * width * quantity <= 7.999) {
      priceRule = 202.8;
    }

    if (height * width * quantity > 7.999 && height * width * quantity <= 9.999) {
      priceRule = 183.3;
    }

    if (height * width * quantity > 9.999 && height * width * quantity <= 14.999) {
      priceRule = 165.1;
    }

    if (height * width * quantity > 14.999) {
      priceRule = 149.5;
    }
  }
}

const priceVisualizer = () => {
  getRules();

//  if (reviewCheckbox.checked) {
//    review = 1.5;
//  } else {
//    review = 0;
//  }

//  if (deadlineCheckbox.checked) {
//    deadline = 9.9;
//  } else {
//    deadline = 0;
//  }

  finalPrice = parseFloat(
    height * width * quantity * (priceRule * 0.95) + deadline + review + 6
  );

  if (finalPrice > 0) {
    priceDiv.innerText = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(finalPrice);
    priceUnitdiv.innerText = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(finalPrice / quantity);
  } else {
    priceDiv.innerHTML = "<p>Preencha os campos e visualize o preço</p>";
    priceUnitdiv.innerText = "R$ 0,00";
  }
};

formFields.forEach((field) => {
  field.addEventListener("input", () => {
    checkField(field);
  });
  field.addEventListener("input", () => {
    checkCompletedFields(field);
  });
  field.addEventListener("input", priceVisualizer);
  field.addEventListener("invalid", (event) => event.preventDefault());
});

formRadioFields.forEach((field) => {
  field.addEventListener("change", () => checkField(field));
  field.addEventListener("input", () => {
    checkCompletedFields(field);
  });
  field.addEventListener("change", priceVisualizer);
  field.addEventListener("invalid", (event) => event.preventDefault());
});

function checkField(field) {
  if (
    field instanceof HTMLInputElement ||
    field instanceof HTMLSelectElement ||
    field instanceof HTMLTextAreaElement
  ) {
    let message = "";
    field.setCustomValidity("");
    if (field.type === "radio") {
      const radioGroup = document.querySelectorAll(
        `input[name='${field.name}']`
      );

      const isSelected = Array.from(radioGroup).some((radio) => radio.checked);

      if (!isSelected) {
        console.error("Selecione uma opção");
        return;
      } else {
        console.log("Campo preenchido");
      }
    }
    if (
      (field.name == "width" || field.name == "height") &&
      field.value != ""
    ) {
      validateSize(field);
    }

    if (
      field.name == "quantity" &&
      field.value != ""
    ) {
      validateQuantity(field);
    }

    if (field.name == "artwork") {
      console.log(field);
      validateArtwork(field);
    }

    if (field.name == "picture__input") {
      validatePicture(field);
    }

    errorTypes.forEach((error) => {
      if (field.validity[error]) {
        message = messages[field.name][error];
        console.log(message);
      }
    });
    const errorMessage = field.parentNode.querySelector(".mensagem-erro");
    const inputValidator = field.checkValidity();

    if (!inputValidator) {
      console.error(`Invalid field: ${field.name}, Error: ${message}`);
      errorMessage.textContent = message;
    } else {
      console.log(`Valid field: ${field.name}`);
      errorMessage.textContent = "";
    }
  }
}

function checkCompletedFields() {
  let allFilled = true;
  let allValid = true;
  const radioGroups = new Set();

  formFields.forEach((field) => {
    if (field.type !== "radio") {
      if (!(artworkCheckbox.value === "Sim") && field.id === "picture__input") {
        return;
      }

      if (!field.value || !field.checkValidity()) {
        allFilled = false;
        allValid = false;
      }
    }

    if (field.type === "radio") {
      radioGroups.add(field.name);
    }
  });

  radioGroups.forEach((name) => {
    const radioGroup = document.querySelectorAll(`input[name='${name}']`);
    if (!Array.from(radioGroup).some((radio) => radio.checked)) {
      allFilled = false;
    }
  });

  submitButton.disabled = !(allFilled && allValid);
}

priceVisualizer();
